import { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import { useFormikContext } from "formik";

import { AddFareZone } from "../../types/AddFareZone";
import { EditFareZone } from "../../types/EditFareZone";
import { FareZone } from "../../types/FareZone";

import OperatorService from "../../services/OperatorsService";

import { ErrorMessage } from "../../@ui/ErrorMessage";
import SearchableMultiSelect from "../searchableMutliSelect/SearchableMultiSelect";
import { useAlertContext } from "../alert/AlertContext";
import { Operator } from "../../types/Operator";

export interface FareZoneFormOperatorsTabProps {
  currentFareZone: FareZone | undefined;
  reviewMode: boolean;
}

const FareZoneFormOperatorsTab = ({
  currentFareZone,
  reviewMode,
}: FareZoneFormOperatorsTabProps) => {
  const { errors, touched, setFieldValue } = useFormikContext<
    AddFareZone | EditFareZone
  >();
  const mapNocTntoPublicName = (operators: Operator[]): Operator[] => {
    return operators.map((o) => ({
      noc: o.noc,
      publicName: `${o.publicName} (${o.noc})`,
    }));
  };

  const [operators, setOperators] = useState<Operator[]>(
    mapNocTntoPublicName(currentFareZone?.operators ?? []),
  );

  const alertContext = useAlertContext();

  const operatorService = useMemo(
    () => new OperatorService(alertContext.showAlert),
    [alertContext],
  );

  useEffect(() => {
    setFieldValue(
      "operatorNOCs",
      operators.map((o) => o.noc),
    );
  }, [operators]);

  const getOperators = (filter: string) => {
    return operatorService
      .getAll(filter)
      .then((operators) => mapNocTntoPublicName(operators));
  };

  return (
    <>
      <Form.Group>
        <Form.Label htmlFor="operators">Operators</Form.Label>
        {errors.operatorNOCs && touched.operatorNOCs && (
          <ErrorMessage>{errors.operatorNOCs?.toString()}</ErrorMessage>
        )}
        <SearchableMultiSelect
          id="operators"
          minSearchLength={2}
          displayProperty="publicName"
          value={operators}
          dataCallback={getOperators}
          onChange={setOperators}
          disabled={reviewMode}
          readOnly={reviewMode}
        />
      </Form.Group>
    </>
  );
};

export default FareZoneFormOperatorsTab;
